module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-lueftung-d2189dc0170a84ded49cbab986957465.svg";